// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.N9ShclVmucmRXA3bfoHo{margin:24px 54px 0 60px}.JUP_K3Q0EeYxHubDarlW{flex-direction:column;flex:1;padding-left:32px;padding-right:76px;display:flex;position:relative;overflow:auto}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"guidelineAlert": `N9ShclVmucmRXA3bfoHo`,
	"dialog": `JUP_K3Q0EeYxHubDarlW`
};
export default ___CSS_LOADER_EXPORT___;
